import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/core/services/auth.service';
import { SearchService } from 'src/app/core/services/search.service';
import { environment } from 'src/environments/environment';
import { ShoppingCartComponent } from 'src/app/components/shopping-cart/shopping-cart.component';
import { Subscription } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { CartService } from 'src/app/core/services/cart.service';
import { EditProfileComponent } from 'src/app/components/profile/edit-profile/edit-profile.component';
import { WalletService } from 'src/app/core/services/wallet.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { AllRequestModalComponent } from 'src/app/components/profile/all-request-modal/all-request-modal.component';
import { SuccessMessageComponent } from 'src/app/components/all-modals/success-message/success-message.component';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { LOCAL_STORAGE_CONSTANT } from 'src/app/core/services/local-storage.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { ChatService } from 'src/app/core/services/chat.service';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { UtilsService } from 'src/app/core/services/utils.service';
import { Location } from '@angular/common';
import { ErrorMessageComponent } from 'src/app/components/all-modals/error-message/error-message.component';
declare var Stripe: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Input() searchFlag: boolean;
  @Input() hideSideBarIcon;
  @ViewChild('searchElement', { static: true }) searchElement: ElementRef;

  isPriceAvailable: boolean;
  showInput: boolean = false;
  searchWord: string;
  currentuser: any;

  headerSubscription: Subscription;
  serchSubscription;
  flag: any = false;
  routePage: any;
  currentUser: any;
  imgURL: string = environment.url;
  baseURL = environment.url;
  userTokens: any;
  isProfileClicked: boolean = false;
  isWalletClicked: boolean = false;
  isChatSelected: boolean = false;
  isNotificationSelected: boolean = false;
  isUnreadedNotification = false;
  notifications = [];
  notificationsChat = [];
  userData: any;
  isChatNotification: boolean = false;
  showNotificationLoader: boolean = false;
  cartCount;
  updateTokensEveryTenSeconds: NodeJS.Timer;
  pageSize = 10;
  currentPage = 1;

  constructor(
    public route: ActivatedRoute,
    private modalService: NgbModal,
    private _authService: AuthService,
    private router: Router,
    private _serchService: SearchService,
    private spinner: NgxSpinnerService,
    public authService: AuthService,
    private _cartService: CartService,
    private _walletService: WalletService,
    private _profileService: ProfileService,
    private webSocketService: WebsocketService,
    private chatService: ChatService,
    private _localStorageService: LocalStorageService,
    private dbService: NgxIndexedDBService,
    public utilService: UtilsService,
    private location: Location,
  ) {
    this.route.queryParams.subscribe(params => {
      if (params && params.notification_id) {
        const param = params.notification_id + '/read';
        this._profileService.markhNotifications(param).subscribe(
          (response: any) => {
          });
      }
      if (params && params.source == 'cart') {

        if (params.payment_intent_client_secret) {
          this.check3Dsecure(params);
        } else if (params.status == 'false' && params.payment_id) {
          this.canclePayment(params.payment_id);
        } else {
          this.openShoppingCart(true);
        }

      }
      this.openHeaderNotification();
    });
    this.serchSubscription = this._serchService.serchFlag.subscribe((item) => {
      if (item) {
        this.flag = item;
      }
      this.clearResult();
      this.flag = false;
    });
    this.headerSubscription = this._authService.loadHeader().subscribe(
      (item) => {
        this.loadImage();
      });
    if (!this.router.url.includes('/search-page') && !this.router.url.includes('/advertisement')) {
      this.location.replaceState(this.router.url.split('?')[0]);
    }
  }

  ngOnInit() {
    this.currentuser = this.authService.getCurrentUser();
    this.loadTokens();
    // to add the cart items if added
    this.updateTokensEveryTenSeconds = setInterval(() => {
      this.loadTokens();
    }, 10000)
    this.loadImage();
    this.loadNotifications();
    this.openConnection();
    this.route.params.subscribe(price => {
      this.isPriceAvailable = price.flag;
    });
  }

  openConnection() {
    // Open a connection and obtain a reference to the channel
    this.chatService.messages.subscribe(msg => {

      this.currentuser = this.authService.getCurrentUser();
      if (msg.hasOwnProperty('author') && msg.author) {

        if (msg.author !== this.currentUser.user.chat_sku) {

          this.isChatNotification = true;
          // const sku = {
          //   id: msg.author
          // };

          // this.dbService.getByIndex('notification_users', 'chat_sku', msg.author).then(
          //   person => {
          //     if (!person) {
          //       this.chatService.getUserDetailBySku(sku).subscribe((res) => {
          //

          //         if (res.success) {
          //           const userData = res.data.user;
          //           const notifObj = {
          //             id: userData.chat_sku,
          //             name: userData.name,
          //             count: 0,
          //             qty: 1,
          //             msg: msg.body,
          //             time: msg.createdAt
          //           }


          //           this.notificationsChat.push(notifObj);
          //           this.dbService.add('notification_users',
          //             {
          //               user_id: userData.id, username: userData.username, name: userData.name,
          //               email: userData.email, avatar: userData.avatar, chat_sku: userData.chat_sku
          //             }).then(
          //               () => {

          //                 // Do something after the value was added
          //               },
          //               error => {

          //               }
          //             );
          //         }
          //       });
          //     } else {

          //       const notifObj = {
          //         id: person.chat_sku,
          //         name: person.name,
          //         count: 0,
          //         qty: 1,
          //         msg: msg.body,
          //         time: msg.createdAt
          //       }
          //       this.notificationsChat.push(notifObj);
          //     }
          //     this.notificationsChat = this.groupBySum(this.notificationsChat.reverse());
          //   });
        }
      }
      if(msg.hasOwnProperty('is_cartUpdated') && msg.is_cartUpdated){
        this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
        this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
        if(this.userData && msg.user_id == this.currentUser.user.id){
          this.cartCount = parseInt(msg.cartCount,10);
        }
      }
      if (msg.hasOwnProperty('is_deleted') && msg.is_deleted) {

        this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
        this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';

        if(this.userData &&  msg.user_id === this.currentUser.user.chat_sku){
          this.webSocketService.offlineSocket(this.userData['chat_sku']);
          this.webSocketService.disconnectSocket();
          this._localStorageService.clearAll();
          this.router.navigate(['/']);
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = 'As you have created delete account request you can not access your account. Please login to activate your account.';
        }

        if(msg.sa_user_sku_ids && msg.sa_user_sku_ids.length){
          const currentChatSku = msg.sa_user_sku_ids.find((el)=>el === this.currentUser.user.chat_sku);
          if(currentChatSku){
            this.webSocketService.offlineSocket(this.userData['chat_sku']);
            this.webSocketService.disconnectSocket();
            this._localStorageService.clearAll();
            this.router.navigate(['/']);
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = 'Your account has been deactivated. Please contact your parent.';
          }
        }
      }
    },
      error => {

      }
    );

  }


  loadImage() {
    this.spinner.show();
    this.currentUser = this._authService.getCurrentUser();

    // this.imgURL = environment.url;
    // if (this.currentUser && this.currentUser.user.avatar)
    //   this.imgURL += this.currentUser.user.avatar;
    // else
    //   this.imgURL = null;

    this.spinner.hide();
  }

  groupBySum(array) {


    var result = [];
    array.reduce(function (res, value) {
      if (!res[value.id]) {
        res[value.id] = { id: value.id, name: value.name, msg: value.msg, time: value.time, qty: 0 };
        result.push(res[value.id])
      }
      res[value.id].qty += value.qty;
      return res;
    }, {});

    return result;

  }

  goToSearch() {
    if (this.flag) {
      this.router.navigate(['/search-page'], { queryParams: { searchQuery: this.searchWord } });
    }
    this.flag = true;
    this.searchElement.nativeElement.focus();
  }

  searchData(event) {

    if (event.keyCode === 13 && this.searchWord) {
      this.router.navigate(['/search-page'], { queryParams: { searchQuery: this.searchWord.trim() } });
      // this.flag = false;
      // this.searchWord = '';
    }
  }

  hideInput() {
    if (!this.searchWord)
      this.flag = false;
  }

  clearResult() {
    // this.flag = false;
    this.searchWord = '';
    // this.router.navigate(['/search-page'], { queryParams: { searchQuery: this.searchWord } });
  }

  openShoppingCart(walletRedirect = false) {
    const modalRef = this.modalService.open(ShoppingCartComponent, {
      windowClass: 'right',
      keyboard: false,
      backdrop: 'static'
    });
    modalRef.componentInstance.walletRedirect = walletRedirect;
    modalRef.result.then(() => {
      this._cartService.shoppingCartModalSource.next('modal_closed');
    })

    if (document.body.classList.contains('show-shoping-modal')) {
      document.body.classList.remove("show-shoping-modal");
    } else {
      document.body.classList.add("show-shoping-modal");
    }
  }

  openSidebar() {
    if (document.body.classList.contains('toggle-nav')) {
      document.body.classList.remove("toggle-nav");
      document.body.classList.add("show-menu");
      //el.classList.remove("toggle-nav");
    } else {
      document.body.classList.add("toggle-nav");
      document.body.classList.remove("show-menu");
      //el.classList.add("toggle-nav");
    }
  }

  chatNotificationClick(event) {
    this.isChatSelected = !this.isChatSelected;
    this.notificationsChat = [];
    this.showNotificationLoader = true;
    this.isNotificationSelected = false;
    this.isWalletClicked = false;
    this.isProfileClicked = false;
    this.isChatNotification = false;
    event.stopPropagation();
    this.chatService.getNotificationList().subscribe((res) => {
      this.showNotificationLoader = false;
      if (res.success) {
        if (res.data.connections && res.data.connections.length) {
          // this.notificationsChat = [...this.notificationsChat, ...res.data.connections];
          this.notificationsChat = res.data.connections || [];
          this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
            this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
          this.notificationsChat.forEach((val) => {
            // console.log(val);

            if (val.recipient) {
              if (val.recipient.message_information.content_type && val.recipient.message_information.content_type.includes('image')) {
                val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a photo' : `${val.recipient.user_name} sent you a photo`;
              }
              if (val.recipient.message_information.content_type && val.recipient.message_information.content_type.includes('audio')) {
                val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a voice clip' : `${val.recipient.user_name} sent you a voice clip`;
              }
              if (val.recipient.message_information.content_type && val.recipient.message_information.content_type.includes('video/mp4') ) {
                val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a video' : `${val.recipient.user_name} sent you a video`;
              }
              if (val.recipient.message_information.content_type && val.recipient.message_information.content_type.includes('application/pdf') ) {
                val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a file' : `${val.recipient.user_name} sent you a file`;
              }
              if (val.recipient.message_information.content_type && val.recipient.message_information.content_type.includes('video/quicktime') ) {
                val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a video' : `${val.recipient.user_name} sent you a video`;
              }
              // if (val.recipient.message_information.content_type && !val.recipient.message_information.content_type.includes('video/mp4') && !val.recipient.message_information.content_type.includes('video/quicktime') && !val.recipient.message_information.content_type.includes('audio') && !val.recipient.message_information.content_type.includes('text') && !val.recipient.message_information.content_type.includes('image')) {
              //   val.recipient.message_information.message = this.userData.chat_sku === val.recipient.message_information.author ? 'You sent a file ' : `${val.recipient.user_name} sent you a file`;
              // }
            } else {
              const sender = val.recipients.find((user) => {
                return val.message_data.message_information.author === user.chat_sku;
              });
              if (val.message_data && val.message_data.message_information && val.message_data.message_information.type == 'group_event') {
                val.message_data.message_information.message = this.createGroupEvent(val.message_data.message_information.message);
                return;
              }
              if (!sender) {
                return;
              }
              if (val.message_data && val.message_data.message_information && val.message_data.message_information.content_type.includes('image')) {
                val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a photo' : `${sender.name} sent a photo`;
              } else if (val.message_data && val.message_data.message_information && val.message_data.message_information.content_type.includes('audio')) {
                val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a voice clip' : `${sender.name} sent a voice clip`;
              }else if (val.message_data && val.message_data.message_information && val.message_data.message_information.content_type.includes('video/mp4') ){
              val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a video' : `${sender.name} sent a video`;
             }else if (val.message_data && val.message_data.message_information && val.message_data.message_information.content_type.includes('video/quicktime') ){
              val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a video' : `${sender.name} sent a video`;
             } else if (val.message_data && val.message_data.message_information && val.message_data.message_information.content_type.includes('application/pdf')){
              val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a file' : `${sender.name} sent you a file`;
             }

             //  else if (val.message_data && val.message_data.message_information && !val.message_data.message_information.content_type.includes('audio') && !val.message_data.message_information.content_type.includes('text') && !val.message_data.message_information.content_type.includes('image')) {
             //     val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? 'You sent a file ' : `${sender.name} sent a file `;
             //   }
              else {
                val.message_data.message_information.message = this.userData['chat_sku'] === val.message_data.message_information.author ? `You: ${val.message_data.message_information.message}` : `${sender.name}: ${val.message_data.message_information.message}`;
              }
            }
          });
          this.notificationsChat.sort((a, b) => {
            if (b.message_data && b.message_data.message_information && b.message_data.message_information.message_created_at) {
              return (b.message_data.message_information.message_created_at > a.message_data.message_information.message_created_at) ? 1 : ((b.message_data.message_information.message_created_at < a.message_data.message_information.message_created_at) ? -1 : 0);
            } else {
              return b - a;
            }
          });
          if (this.notificationsChat.length > 5) {
            this.notificationsChat.length = 5;
          }
          this.notificationsChat = this.notificationsChat.filter((val) => {
            return (val.recipient && val.recipient.message_information.message) || (val.group_chat_sku && val.message_data.message_information.message);
          });
        }
      }
    });
  }
  createGroupEvent(msg) {
    let message;
    message = JSON.parse(msg);
    const userName = message.business_username ? message.business_username : message.userName;
    const adminName = message.admin_business_username ? message.admin_business_username : message.adminName;
    switch (message.event) {
      case "new admin":
        msg = userName + ' left the group.\n';
        msg += ((this.currentUser.user.chat_sku == message.adminSku) ? 'You are' : (adminName + ' is')) + ' now the admin';
        break;
      case "user removed":
        msg = ((this.currentUser.user.chat_sku == message.adminSku) ? 'You' : adminName) + ' removed ' + ((this.currentUser.user.chat_sku == message.userSku) ? 'You' : userName);
        break;
      case "new disconnect":
        if (this.currentUser.user.chat_sku === message.userSku) {
          msg = 'You left the group';
        } else {
          msg = userName + ' left the group';
        }
        break;
      case "new member":
        const addedUsersName = message.users.participants.map(user => {
          if (user.business_username) {
            return user.business_username;
          } else {
            return user.userName;
          }
        });
        const addedUsersSKU = message.users.participants.map(user => user.userSku);
        const addAdminName = message.users.admin_business_username ? message.users.admin_business_username : message.users.adminName;
        if (this.currentUser.user.chat_sku == message.creator) {
          msg = 'You added ';
          msg += addedUsersName.join(',');
        } else if (addedUsersSKU.includes(this.currentUser.user.chat_sku)) {
          msg = `You were added by ${addAdminName}`;
        } else {
          msg = `${addAdminName} added `;
          msg += addedUsersName.join(',');
        }
        break;
      case "new group":
        if (this.currentUser.user.chat_sku == message.creator) {
          msg = 'You created group';
        } else {
          msg = `You were added by ${adminName}`;
        }
        break;
        case "title change":
          if (this.currentUser.user.chat_sku == message.userSku) {
            msg = `You changed the title to ${message.groupName}`;
          } else {
            msg = `${message.userName} changed the title to ${message.groupName}`;
          }
          break;
    }
    return msg;
  }

  chatUserClick(notification) {
    if (notification.recipient) {
      this.chatService.notificationData.next(notification.recipient.user_info.chat_sku);
      this._localStorageService.setItem('chatNotifUser', notification.recipient.user_info.chat_sku);
    } else {
      this.chatService.notificationData.next(notification.group_chat_sku);
      this._localStorageService.setItem('chatNotifUser', notification.group_chat_sku);
    }

    this.router.navigate(['/chats']);
  }

  openHeaderNotification() {
    document.body.onclick = () => {
      const el = document.querySelector(".notify-tooltip.show");
      if (el) {
        el.classList.remove("show");
        this.isWalletClicked = false;
        this.isChatSelected = false;
        this.isNotificationSelected = false;
        this.isProfileClicked = false;
      }

    }
    // // e.target.closest('.header-notification-box-style').remove();
    // const el = document.querySelector('.');

    // if (el.classList.contains('show')) {
    //   el.classList.remove("show");
    // } else {
    //   el.classList.add("show");
    // }
    // //  document.body.addEventListener("click", function (evt) {
    // //          el.classList.remove("show");
    // //  });
  }

  removeAll() {
    document.body.classList.add("toggle-nav");
    document.body.classList.remove("show-menu");

    // document.body.addEventListener("click", function (evt) {
    // alert("121");
    // });
  }

  openEditProfileModal() {
    const modalRef = this.modalService.open(EditProfileComponent, { size: 'lg', centered: true });
    modalRef.result.then(
      (response) => {
        if (response)
          this._authService.setHeader();
        this._authService.setSidebar();
      }, (reason) => {
      });
  }

  loadTokens() {
    // this.spinner.show();
    this.currentuser = this.authService.getCurrentUser();
    this._walletService.loadTokens().subscribe(
      (response: any) => {
        // this.spinner.hide();
        if (response.success) {
          this.userTokens = response.data.account;
          this.cartCount = response.data.account.cart_items_count;
        }
      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }
  loadNotifications(param = '') {
    this._profileService.fetchNotifications(param).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.notifications = response.data.notifications;
          this.isUnreadedNotification = this.notifications.find((element) => {
            return element.status == 'unread';
          });
        }
      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }

  markAllNotifications(param = '') {
    this._profileService.markhNotifications(param).subscribe(
      (response: any) => {
        this.spinner.hide();
        if (response.success) {
          const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modelRef.componentInstance.message = response.message;
          this.loadNotifications();
        } else {
          // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        }
      }, (error: any) => {
        // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
      });
  }
  markSingleNotification(notification) {
    if (notification.status !== 'read') {
      const param = notification.id + '/read';
      this._profileService.markhNotifications(param).subscribe(
        (response: any) => {
          if (response.success) {
            this.loadNotifications();
          } else {
            // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
          }
        }, (error: any) => {
          this.spinner.hide();
          // this._toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
    }

    switch (notification.notifiable_type) {
      case "Testimonial":
        const navigationExtrasT: NavigationExtras = {
          queryParams: {
            notification: 'testimonial'
          }
        };
        if (notification.redirect_to_type != "ContentCollection") {
          if (notification.redirect_to_id) {
            this.router.navigate(['/material-detail-page', notification.redirect_to_id, 'public'], navigationExtrasT);
          } else if (notification.notifiable && notification.notifiable.content_id) {
            this.router.navigate(['/material-detail-page', notification.notifiable.content_id, 'public'], navigationExtrasT);
          }
        } else {
          this.router.navigate(['/collection', notification.slug], navigationExtrasT);
        }

        break;
      case "Subscription":
        const extras: NavigationExtras = {
          queryParams: {
            source: 'noitfication'
          }
        };
        this.router.navigate(['/plans-page'], extras);
        break;
      case "Plan":
        this.router.navigate(['/plans-page']);
        break;
      case "PurchasedAddOn":
        this.router.navigate(['/plans-page']);
        break;
      case "Connection":
        if (notification.action == 'accepted' && notification.redirect_to_id) {
          this.router.navigate(['other-profile', notification.redirect_to_id])
        } else if (notification.action == 'sent') {
          // const modalRef = this.modalService.open(AllRequestModalComponent, { size: 'lg', centered: true });
          // modalRef.result.then((response) => {
          //   this.loadNotifications('see_all=true');
          // }, (reason) => {
          //   this.loadNotifications('see_all=true');
          // });
          const navigationExtrasConn: NavigationExtras = {
            queryParams: {
              page: 'allrequestconnection'
            }
          };
          this.router.navigate(['/my-profile'], navigationExtrasConn);
        } else if (!notification.notifiable) {
          this.router.navigate(['/my-profile'])
        }
        break;
      case "GiftedToken":
        const navigationExtrasGift: NavigationExtras = {
          state: {
            id: notification.redirect_to_id
          }
        };
        this.router.navigate(['/wallet'], navigationExtrasGift)
        break;
      case "Advertisement":
        const action = (notification.action) ? notification.action : 'rejected';
        const navigationExtras: NavigationExtras = {
          queryParams: {
            action: action
          }
        };
        this.router.navigate(['/manage-advertisement'], navigationExtras);
        break;
      case "Content":
        if (notification.supplementry_user) {
          if (notification.remarks.includes("shared a material")) {
            this.router.navigate(['/material-detail-page', notification.redirect_to_id, 'public']);
          }
          else {
            const navigationExtras: NavigationExtras = {
              queryParams: {
                action: 'private',
                content_id: notification.notifiable.id
              }
            };
            this.router.navigate(['/supplementary-account/supplementary-account-detail', notification.supplementry_user_id], navigationExtras);
          }
        }
        else if (notification.action) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              type: 'all'
            }
          };
          this.router.navigate([notification.action], navigationExtras);
        } else if (notification.redirect_to_id) {
          this.router.navigate(['/material-detail-page', notification.redirect_to_id, 'public']);
        } else if (notification.notifiable && notification.notifiable.content_id) {
          this.router.navigate(['/material-detail-page', notification.notifiable.id, 'public']);
        }
        break;
      case "GiftedContent":
        const navigationExtras1: NavigationExtras = {
          queryParams: {
            type: "gifted",
            status: notification.notifiable.status,
            pendingGiftId: notification.notifiable.id,
            content_id: notification.notifiable.content_id
          }
        };
        this.router.navigate(['/private-library'], navigationExtras1);
        break;
      case "User":
        if (notification.remarks.includes("Your Supplementary account has turned 18")) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              open: 'saturns18',
              id: notification.notifiable.id
            }
          };
          this.router.navigate(['/supplementary-account'], navigationExtras);
          return;
        }
        if (notification.remarks.includes('to expire') || notification.remarks.includes('tokens have expired') || notification.remarks.includes('tokens will be expired')) {
          this.router.navigate(['/wallet']);
        }
        else if (notification.remarks.includes('is upgraded to primary account') || notification.remarks.includes('Please upgrade your plan within') || notification.remarks.includes('Please upgrade your plan before')) {
          this.router.navigate(['/plans-page']);
          return;
        } else {
          const navigationExtrasSetting: NavigationExtras = {
            queryParams: {
              type: "verification",
            }
          };
          this.router.navigate(['/settings'], navigationExtrasSetting)
        }
        break;
      case "Verification":
        const navigationExtrasSetting: NavigationExtras = {
          queryParams: {
            type: "verification",
          }
        };
        this.router.navigate(['/settings'], navigationExtrasSetting);
        break;
      case "Subscriber":
        if (notification.remarks.includes('would like to subscribe')) {
          // const modalRef = this.modalService.open(AllRequestModalComponent, { size: 'lg', centered: true });
          // modalRef.componentInstance.subscribe = true;
          // modalRef.result.then((response) => {
          //   this.loadNotifications('see_all=true');
          // }, (reason) => {
          //   this.loadNotifications('see_all=true');
          // });
          const navigationExtrasConn: NavigationExtras = {
            queryParams: {
              page: 'allsubscriberrequest'
            }
          };
          this.router.navigate(['/my-profile'], navigationExtrasConn);
          break;
        }
        if (notification.remarks.includes('has accepted') || (notification.remarks.includes('You have successfully subscribed'))||(notification.remarks.includes('has been added to your subscriber') || notification.remarks.includes('has been subscribed to your paid subscription')) || (notification.remarks.includes('You have successfully canceled')) || (notification.remarks.includes('Your paid subscription pack to')) && notification.redirect_to_id) {
          this.router.navigate(['other-profile', notification.redirect_to_id])
          break;
        }
        if (notification.remarks.includes('into his public library') && notification.redirect_to_id) {
          this.router.navigate(['/material-detail-page', notification.redirect_to_id, 'public']);
          break;
        }
        if (notification && notification.notifiable && notification.notifiable.paid_subscriber && notification.remarks.includes('status in wallet')) {
          this.router.navigate(['/wallet']);
          break;
        }
        if ((notification.remarks.includes('subscription pack has been updated the price and new price is') || notification.remarks.includes('has been expired and now you will be') || notification.remarks.includes('Your paid subscription pack for')) && notification.redirect_to_id) {
          this.router.navigate(['other-profile', notification.redirect_to_id])
          break;
        }
        if (notification.remarks.includes('has been expired and now you will be') && (!notification.redirect_to_id && notification.notifiable && notification.notifiable.recipient_id)) {
          this.router.navigate(['other-profile', notification.notifiable.recipient_id]);
          break;
        }
        if (notification.remarks.includes('could not renew your paid subscription pack')) {
          this.router.navigate(['other-profile', notification.redirect_to_id]);
          break;
        }
        this.router.navigate(['my-profile'])
        break;
      case "Payment":
        this.router.navigate(['/wallet']);
        break;
      case "WithdrawRequest":
        this._walletService.setTransaction(true);
        this.router.navigate(['/wallet']);
        break;
      case "SuppelementaryConnection":
        if (notification.redirect_to_id == notification.notifiable.sender_id) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              action: 'connections',
              status: 'sent'
            }
          };
          this.router.navigate(['/supplementary-account/supplementary-account-detail', notification.supplementry_user_id], navigationExtras);
        } else if (notification.redirect_to_id) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              action: 'connections',
              status: 'received'
            }
          };
          this.router.navigate(['/supplementary-account/supplementary-account-detail', notification.redirect_to_id], navigationExtras);
        }
        break;
      case "ContentCollection":
        if ((notification.remarks.includes('has shared') || notification.remarks.includes('has published')) && notification.notifiable && notification.notifiable.slug) {
          this.router.navigate(['/collection', notification.notifiable.slug]);
        }
        break;
      case "OutletSubscriber":
        if (notification.redirect_to_type == 'Subscriber') {
          this.router.navigate(['/other-profile', notification.redirect_to_id])
        } else {
          this.router.navigate(['/public-library-content', notification.redirect_to_id])
        }
        break;

      case "Collaboration":
        if (notification.remarks.includes('collaborated with you') && notification.notifiable && notification.notifiable.status == 'pending') {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              from: 'notification',
            }
          };
          this.router.navigate(['/collabration-request'], navigationExtras);
        }
        else if (notification.remarks.includes('has accepted your collaboration')
          && notification.notifiable) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              for: 'myCollab',
              contentID: notification.redirect_to_id,
              status: 'approved',
              from: 'notification',
            }
          };
          this.router.navigate(['/collaborated-material'], navigationExtras);
        }
        else if (notification.remarks.includes('has rejected your collaboration')
          && notification.notifiable) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              for: 'myCollab',
              contentID: notification.redirect_to_id,
              status: 'declined',
              from: 'notification',
            }
          };
          this.router.navigate(['/collaborated-material'], navigationExtras);
        }
        else if (notification.remarks.includes('access period is over') ||
          notification.remarks.includes('author might have removed rights') ||
          notification.remarks.includes('has changed the collaboration rights') ||
          notification.remarks.includes('as you are not in connection')) {
          const navigationExtras: NavigationExtras = {
            queryParams: {
              type: 'collaborated',
              activeFlag: 'others',
            }
          };
          this.router.navigate(['/wipod'], navigationExtras);
        }
        break;

      default:
        break;
    }
  }

  logOut() {
    let uploadingProcess = this._localStorageService.getItem('uploadingProcess');

    if (uploadingProcess != true) {
      this.callLogOutAPI();
    }
    else {
      var userselection = confirm("The changes you made may not be saved. Are you sure you want to logout?");
      if (userselection == true) {
        this.callLogOutAPI();
      }
    }
  }

  callLogOutAPI(flag?) {
    this.userData = this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS) ?
      this._localStorageService.getItem(LOCAL_STORAGE_CONSTANT.USER_DETAILS).user : '';
    this.spinner.show();
    this._authService.logOut().subscribe(
      (response: any) => {
        this.spinner.hide();
        if (this.userData) {
          this.webSocketService.offlineSocket(this.userData['chat_sku']);
          this.webSocketService.disconnectSocket();
        }
        this._authService.cancelUploadingFileDetect(true);
        this._authService.clearStorage();
        this.router.navigate(['/']);
        if (flag) {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = 'Your account is deactivated.';
        }
      }, (error: any) => {
        this.spinner.hide();
      });
  }

  /**
     * restrict %
     *
     * @param {*} event
     * @returns
     * @memberof AddTokensComponent
     */
  restrictNumeric(event) {
    const restrictKeycodes = [37];
    if (restrictKeycodes.includes(event.keyCode)) {
      return false;
    }
  }

  check3Dsecure(param) {
    const stripe = Stripe(environment.stripe_publication_key);
    stripe.retrievePaymentIntent(param.payment_intent_client_secret)
      .then((result) => {
        if (result.error) {
          // PaymentIntent client secret was invalid
        } else {
          if (result.paymentIntent.status === 'succeeded') {
            // Show your customer that the payment has succeeded
            this.openShoppingCart(true);
          } else if (result.paymentIntent.status === 'requires_payment_method') {
            this.canclePayment(param.payment_id)
            // Authentication failed, prompt the customer to enter another payment method
          }
        }
      });


  }

  canclePayment(payment_id) {
    const obj = {
      payment_id: payment_id
    }
    this._walletService.cancelPayment(obj).subscribe(
      (response) => {
        if (response.success)
          this.openShoppingCart(true);
        else
          this.openShoppingCart(false)
      }, (error) => {
        this.openShoppingCart(true);
      });
  }

  // Had to use this function to clear the setInterval to
  ngOnDestroy() {
    clearInterval(this.updateTokensEveryTenSeconds)
  }
}
